(function userAddIntegratedControllerDefinition() {
    'use strict';
    angular.module('User')
        .controller('UserAddIntegratedController', [
            '$scope', 'config', '$state', '$stateParams', '$translate', 'errorsExtend', 'adminUserService', 'authExtend', 'organizationalUnitService',
            function UserAddIntegratedController($scope, config, $state, $stateParams, $translate, errors, adminUserService, authExtend, organizationalUnitService) {

                $scope.userOu =
                {
                    nickName: $stateParams.userName,                    
                    fullName: '',
                    password: '',
                    mail: '',
                    mailConfirm: '',
                    enabled: true,
                    organizationalUnitId: null,
                    organizationalUnitName: null,
                    isLdap: true
                };

                $scope.enableControls = true;

                $scope.title = 'UserAdd';
                $scope.requiredOu = false;

                $scope.validMails = function () {
                    if ($scope.userOu.mail) {
                        if ($scope.userOu.mail !== $scope.userOu.mailConfirm) {
                            $scope.userForm.email2.$invalid = true;
                            $scope.userForm.email2.$valid = false;
                            return false;
                        } else {
                            $scope.userForm.email2.$invalid = false;
                            $scope.userForm.email2.$valid = true;
                            return true;
                        }
                    }
                    return false;
                }

                $scope.save = function () {
                    if (!$scope.validMails()) {
                        $scope.userForm.$setSubmitted();
                        errors.showError('UserInvalidMailConfirm');
                        return false;
                    }

                    if (!$scope.userForm.$valid) {
                        $scope.userForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    var userOu = angular.copy($scope.userOu);

                    return adminUserService.createFromWindowsIntegrated(userOu).then(function () {
                        $state.go('login');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go("login");
                };

            }
        ]);
})();